/**
 * URL-safe slug from a display name (admin detail routes, public category links).
 */
export function slugifyName(name) {
  return String(name || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

/** True when a record's display name matches a URL name/slug param. */
export function matchesUrlName(value, param) {
  const nameParam = decodeURIComponent(param || '');
  if (!nameParam) return false;
  return (
    slugifyName(value) === nameParam ||
    String(value || '').toLowerCase() === nameParam.toLowerCase()
  );
}

/** Encode a name/slug for use in URL path segments. */
export function urlNameSegment(name) {
  return encodeURIComponent(slugifyName(name));
}
